import isBefore from 'date-fns/isBefore';
import lastDayOfMonth from 'date-fns/lastDayOfMonth';

export const isCardExpired = (
  expMonth: string | number,
  expYear: string | number,
  bookingDate: string
) => {
  const expirationDate = lastDayOfMonth(new Date(+expYear, +expMonth - 1));
  return !isBefore(new Date(bookingDate), expirationDate);
};
